<app-visits-table [tableData]="tableData" [linkRowsCount]="1"></app-visits-table>
